import { useEffect, useState } from 'react';

const CONSULTA = '(max-width: 767px)';

// Breakpoint mobile/desktop compartilhado — 768px bate com o `md` padrão do
// Tailwind já usado no resto do projeto. Usado tanto pela pilha de
// resultado (ResultadoEnqueteDinamica.js: arraste no mobile, empilhamento
// por scroll no desktop) quanto pelo fluxo de votação (FormularioDinamico.js/
// FluxoCartasPerguntas.js: cards um a um só no mobile — no desktop a lista
// plana de sempre). Escuta resize/orientação real (matchMedia + change),
// não só a largura no mount, pra girar o celular ou redimensionar a janela
// trocar de comportamento sem precisar recarregar a página.
export function useEhMobile() {
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(CONSULTA).matches : true
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(CONSULTA);
    const ouvir = (evento) => setMobile(evento.matches);
    mediaQuery.addEventListener('change', ouvir);
    return () => mediaQuery.removeEventListener('change', ouvir);
  }, []);

  return mobile;
}
